import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import { FormControlLabel, Tooltip, Button, Icon, Fab } from '@material-ui/core'
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto'
import { ReactSVG } from 'react-svg'
import {
  applicationUploadIcon,
  applicationUploadSmallIcon,
} from 'reducers/application/reducer'
import { Checkbox } from 'components/common/FormInputs'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import { SVG_IMAGE_TYPE, APP_LANGUAGES } from 'constants/index'
import TextArea from '../common/Form/TextArea'
import ChangeFileDialog from '../licensee/ChangeFileDialog'
import CircleLoader from '../Loading/CircleLoader'

import messages from './translate'

class ApplicationForm extends Component {
  state = {
    isOpenChangeIcon: false,
    isOpenChangeSmallIcon: false,
  }

  handleIconChange = () => {
    this.setState(prevState => ({
      isOpenChangeIcon: !prevState.isOpenChangeIcon,
    }))
  }

  handleSmallIconChange = () => {
    this.setState(prevState => ({
      isOpenChangeSmallIcon: !prevState.isOpenChangeSmallIcon,
    }))
  }

  renderIconBlock = () => {
    const {
      intl: { formatMessage },
      formData: { iconPath },
    } = this.props

    return (
      <div className="logo">
        {iconPath ? (
          <img src={iconPath} alt={formatMessage(messages.applicationIcon)} />
        ) : (
          <AddAPhotoIcon fontSize="large" />
        )}
        <div className="overlay">
          <Tooltip title={formatMessage(messages.changeIcon)}>
            <Fab
              variant="round"
              color="primary"
              aria-label="Add"
              className="control-button edit-logo"
              onClick={this.handleIconChange}>
              <Icon>edit</Icon>
            </Fab>
          </Tooltip>
        </div>
      </div>
    )
  }

  renderSmallIconBlock = () => {
    const {
      intl: { formatMessage },
      formData: { smallIconPath },
    } = this.props

    return (
      <div className="logo">
        {smallIconPath ? (
          <span title={formatMessage(messages.applicationSmallIcon)}>
            <ReactSVG src={smallIconPath} />
          </span>
        ) : (
          <AddAPhotoIcon fontSize="large" />
        )}
        <div className="overlay">
          <Tooltip title={formatMessage(messages.changeSmallIcon)}>
            <Fab
              variant="round"
              color="primary"
              aria-label="Add"
              className="control-button edit-logo"
              onClick={this.handleSmallIconChange}>
              <Icon>edit</Icon>
            </Fab>
          </Tooltip>
        </div>
      </div>
    )
  }

  render() {
    const {
      onSubmit,
      formData,
      applicationLoader,
      applicationUploadIcon,
      applicationUploadSmallIcon,
      intl: { formatMessage },
      match: {
        params: { id },
      },
    } = this.props
    const { isOpenChangeIcon, isOpenChangeSmallIcon } = this.state
    const isCreateApplication = id === 'create'
    const smSize = isCreateApplication ? 12 : 6

    return (
      <Paper className="licensee-paper">
        <Grid container spacing={1}>
          {!isCreateApplication && (
            <Grid item xs={12} sm={6} className="logo-container">
              <Grid container className="logo-block">
                <Grid
                  item
                  container
                  sm={5}
                  alignItems="center"
                  justify="center">
                  {applicationLoader ? (
                    <CircleLoader loading={applicationLoader} />
                  ) : (
                    this.renderIconBlock()
                  )}
                </Grid>
                <Grid
                  item
                  container
                  sm={5}
                  alignItems="center"
                  justify="center">
                  {applicationLoader ? (
                    <CircleLoader loading={applicationLoader} />
                  ) : (
                    this.renderSmallIconBlock()
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item container xs={12} sm={smSize}>
            <Form
              onSubmit={onSubmit}
              initialValues={formData}
              render={({ handleSubmit, submitting, pristine }) => (
                <form
                  onSubmit={handleSubmit}
                  className="form-basic licensee-form">
                  {Object.values(APP_LANGUAGES).map(({ key }) => (
                    <>
                      <Field
                        name={`translations[${key}][name]`}
                        key={`${key}_name`}
                        type="text"
                        label={`${key} ${formatMessage(messages.name)}`}
                        component={Input}
                        className="form-control"
                        disabled={submitting}
                        required={key === 'en'}
                        validate={
                          key === 'en' ? getValidator(VALIDATOR_IS_EMPTY) : null
                        }
                      />
                      <Field
                        name={`translations[${key}][description]`}
                        key={`${key}_description`}
                        type="text"
                        label={`${key} ${formatMessage(messages.description)}`}
                        component={TextArea}
                        className="form-control"
                        disabled={submitting}
                      />
                    </>
                  ))}
                  <FormControlLabel
                    label={formatMessage(messages.active)}
                    disabled={submitting}
                    className="form-group"
                    required
                    control={
                      <Field
                        name="active"
                        component={Checkbox}
                        type="checkbox"
                        color="primary"
                      />
                    }
                  />
                  <div className="form-group buttons">
                    <Button
                      href={null}
                      type="submit"
                      color="primary"
                      size="medium"
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={submitting || pristine}>
                      {formatMessage(messages.saveInfo)}
                    </Button>
                  </div>
                </form>
              )}
            />
          </Grid>
          <ChangeFileDialog
            isOpenLogoChange={isOpenChangeIcon}
            onCloseLogoChange={this.handleIconChange}
            fileUpload={applicationUploadIcon}
            entityId={id}
            title={formatMessage(messages.changeIcon)}
            typesLimitation={[SVG_IMAGE_TYPE]}
          />
          <ChangeFileDialog
            isOpenLogoChange={isOpenChangeSmallIcon}
            onCloseLogoChange={this.handleSmallIconChange}
            fileUpload={applicationUploadSmallIcon}
            entityId={id}
            title={formatMessage(messages.changeSmallIcon)}
            typesLimitation={[SVG_IMAGE_TYPE]}
          />
        </Grid>
      </Paper>
    )
  }
}

ApplicationForm.propTypes = {
  formData: PropTypes.shape({
    active: PropTypes.bool,
    name: PropTypes.string,
    iconPath: PropTypes.string,
    description: PropTypes.string,
    smallIconPath: PropTypes.string,
    translations: PropTypes.shape({
      en: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
      }),
      es: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
      }),
    }),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  applicationLoader: PropTypes.bool.isRequired,
  applicationUploadIcon: PropTypes.func,
  applicationUploadSmallIcon: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
}

ApplicationForm.defaultProps = {
  applicationUploadIcon: () => {},
  applicationUploadSmallIcon: () => {},
  intl: {
    formatMessage: () => '',
  },
  match: {
    params: {
      id: '',
    },
  },
}

export default connect(
  state => ({
    roleLevel: state.getIn(['profile', 'roleLevel']),
    loading: state.getIn(['application', 'loading']),
    applicationLoader: state.getIn(['application', 'applicationLoader']),
  }),
  {
    applicationUploadIcon,
    applicationUploadSmallIcon,
  },
)(injectIntl(ApplicationForm))
